import { EVENTS, REMOVE_TYPE, STORAGE_KEY } from '@/constant/constant';
import { terminal } from '@/constant/index';
import { getQueryVariable, companyUUID, deleteDOM } from '@/service/api';
import { checkConfig, getStrategy } from '@/service/strategy/request';
import { getCompanyStaticUrl } from '@/utils';
import { formEventV2 } from '@/service/formEventV2';
import { shopify } from '@/constant/company';
import { isShopifyOrTest } from '@/utils/platform';
import { getLocal, getSession, setLocal, setSession, removeLocal, removeSession } from '@/utils/storage';
// import { getCookie, removeCookie, setCookie } from "@/cookieLogic";

const debug = require('debug')('cartsee:dataStorage');
const FORM_LOAD_LIMIT_INTERVAL = 1000 * 60 * 5;

const shouldSkipCheckConfigByLoadLimit = (type) => {
  if (`${type}` === '3') return false;
  const lastLoadRequestTime = Number(getSession(STORAGE_KEY.POPUP_LOAD_REQUEST_TIME) || 0);
  return !!lastLoadRequestTime && Date.now() - lastLoadRequestTime < FORM_LOAD_LIMIT_INTERVAL;
};

const ConfigState = {
  Unset: 0,
  Requesting: 1,
  FinishedRequest: 2,
  Failed: 3
};

// 防止误使用，使用订阅模式
class ConfigObserver {
  config: any;
  message: any[];
  state: number;

  constructor() {
    // 配置放在内存里，快
    this.config = undefined;
    this.message = [];
    this.state = ConfigState.Unset;
  }
  // 订阅
  on(fn) {
    if (this.state === ConfigState.FinishedRequest && !!this.config) {
      fn(JSON.parse(JSON.stringify(this.config || {})));
    } else {
      this.message.push(fn);
    }
  }
  // 取消订阅
  off(fn) {
    if (!fn || this.message.length == 0) {
      return;
    }
    const i = this.message.findIndex((f) => f == fn);
    if (i !== -1) {
      this.message.splice(i, 1);
    }
  }
  // 未请求状态验证
  isNotRequesting() {
    return this.state === ConfigState.Unset;
  }
  // 请求中状态验证
  isRequesting() {
    return this.state === ConfigState.Requesting;
  }
  // 是否有配置
  hasConfig() {
    return this.state === ConfigState.FinishedRequest && !!this.config;
  }
  // 设置状态为请求中
  setConfigRequesting() {
    this.state = ConfigState.Requesting;
  }
  setGetConfigFailed() {
    // 不再有失败，失败3次后，删除触发。后续触发会重新请求。
    this.state = ConfigState.Unset;
    // this.state = ConfigState.Failed;
    // 请求失败后，清除所有订阅，防止后续重新触发请求的时候，以前的所有失败弹窗重新触发。
    this.message = [];
  }
  clearConfig() {
    this.config = undefined;
    this.state = ConfigState.Unset;
  }
  // 分发
  emit(conf) {
    if (this.state !== ConfigState.FinishedRequest) {
      this.config = conf;
      this.state = ConfigState.FinishedRequest;
      this.message.forEach((fn) => fn(JSON.parse(JSON.stringify(conf || {}))));
      this.message = [];
    }
  }
  // 检查配置逻辑，如果有本地配置直接读
  readLocalStorage() {
    const config = getAndValidConfig();
    this.config = config;
  }
  // 检查配置逻辑，跟新某一类型的配置
  update(type, res, time) {
    let hasChange = false;
    let configChange = false;
    // 0228添加abtest参数，check接口校验
    if (res?.abMapping) {
      // 后端返回了，直接替换
      // 获取永久存储
      const info = getAbtestInfo();
      if (info) {
        info[type] = res?.abMapping[type];
        storeAbtestInfo(info);
      } else {
        storeAbtestInfo(res.abMapping);
      }
    } else {
      // 后端没返回，本地有，则删除当前的type
      const info = getAbtestInfo();
      if (info) {
        delete info[type];
        storeAbtestInfo(info);
      }
    }

    // 判断是否有最新配置，如果没有就算了
    if (res?.config) {
      const ids = Object.keys(res.config);
      // console.log(res.config, time);
      if (`${type}` === '2' && ids?.length === 0) {
        // 清除加购标记
        removeSession(STORAGE_KEY.ADD_CART_STATE);
      }

      // 过滤出所有其他类型的弹窗
      const list = this.config?.rets?.filter((popItem) => `${popItem?.triggerEventType}` !== `${type}`);
      // 如果返回obj则
      for (let i = 0; i < ids.length; i++) {
        const popId = ids[i];
        if (typeof res.config[popId] === 'object') {
          // console.log('加入列表', popId)
          // 如果有新配置，加入列表
          list.push(res.config[popId]);
          // console.log('长度没改变，有需要更新的数据，则有更新');
          hasChange = true;
        } else {
          // console.log('拿老数据');
          // 如果是老配置，查询以前配置，加入列表
          const oldConfig = this.config?.rets?.find((popItem) => popItem.id === popId);
          // console.log(oldConfig);
          list.push(oldConfig);
        }
      }
      // console.log('新列表',list);
      if (!hasChange) {
        if (this.config.rets.length !== list.length) {
          // console.log('长度改变，则有更新');
          hasChange = true;
        }
      }
      if (hasChange) {
        // console.log('配置有更新');
        configChange = true;
        // 最终结果，用过滤的其他类型弹窗，和返回的id顺序组成新的弹窗配置
        this.config.rets = list;
      }
      // console.log('haschange', hasChange);

      // 悬浮窗规则：更新最新配置
      const triggerPop = getLocal(STORAGE_KEY.TEMP_POP);
      if (triggerPop) {
        const responseData = JSON.parse(triggerPop || '{}');
        let has = false;
        for (let i = 0; i < list?.length; i++) {
          const config = list?.[i];
          // 是否还有这个配置
          if (responseData?.id === config.id) {
            // 加购的图片继承
            if (responseData?.triggerEventType === 2) {
              config?.settings?.typesetting && (config.settings.typesetting.imgUrl = responseData.settings.typesetting.imgUrl);
            }
            debug('localStorage?.setItem(_cartsee_tempPop) 2 %o', responseData);
            setLocal(STORAGE_KEY.TEMP_POP, JSON.stringify(config));
            has = true;
            break;
          }
        }
        // 配置不在了，清除
        if (!has) {
          // console.log('没有配置，清除icon');
          removeLocal(STORAGE_KEY.TEMP_POP);
          // 同时，清除dom
          document?.querySelector('#cartx-icon')?.remove();
          deleteDOM('cartx-wrap');
          // 清除加购弹窗
          deleteDOM('cartx-purchase-wrap');
        }
      }
    }
    // 预加载图片
    // 预加载 灰度450、30、721、313
    // 延时预加载，如果触发弹窗的话，至少等弹窗js懒加载开始
    setTimeout(() => {
      preload02Pop(this.config);
    }, 40);

    if (res?.userStatus) {
      hasChange = true;
      // 重新设置用户状态
      this.config.userStatus = {
        cid: res.userStatus.cid,
        formUid: res.userStatus.formUid
      };
      let hasExpired = true;
      if (!!res.userStatus.cid || !!res.userStatus.formUid) {
        hasExpired = false;
      }

      formEventV2({
        event: 'popup_cid_expired',
        result: hasExpired ? '过期' : '未过期'
      })
        .then((response) => {
          // console.log('数据上报成功')
        })
        .catch((e) => {});
    }
    if (res?.globalSetting && res?.globalSetting?.globalSettingTimestamp) {
      // 全局设置
      hasChange = true;
      configChange = true;
      this.config.formGlobalSetting = {
        maxTrigger: res?.globalSetting?.maxTrigger,
        quiescentPeriod: res?.globalSetting?.quiescentPeriod,
        quiescentState: res?.globalSetting?.quiescentState,
        globalSettingTimestamp: res?.globalSetting?.globalSettingTimestamp
      };
    }

    formEventV2({
      event: 'popup_config_check_result',
      eventType: type,
      result: configChange ? '有更新' : '无更新',
      duration: time
    })
      .then((response) => {
        // console.log('数据上报成功')
      })
      .catch((e) => {});
    if (hasChange) {
      // 更新最新信息
      storeConfig(this.config);
      // 存储本地coupon
      storeCoupon();
    }
  }
}

const observer = new ConfigObserver();

// AB 实验/配置映射（local），策略与埋点用
const getAbtestInfo = () => {
  const info = getLocal(STORAGE_KEY.AB_MAP);
  if (info && info != '') {
    try {
      return JSON.parse(info);
    } catch (error) {}
    return null;
  }
  return null;
};
const storeAbtestInfo = (result) => {
  if (result) {
    setLocal(STORAGE_KEY.AB_MAP, JSON.stringify(result));
  }
};

// 获取本地配置
const getAndValidConfig = () => {
  const config = getSession(STORAGE_KEY.POPUP);
  if (config && config != '') {
    try {
      return JSON.parse(config);
    } catch (error) {}
    return null;
  }
  return null;
};

// 只有这个地方能够存储配置
const storeConfig = (result) => {
  if (result) {
    // 拆分配置和用户信息，进行存储
    const current = new Date();
    result.loadTime = current?.getTime();
    setSession(STORAGE_KEY.POPUP, JSON.stringify(result));

    // 触发配置存储事件
    window.dispatchEvent(
      new CustomEvent(EVENTS.POPUP.STORED, {
        detail: result
      })
    );

    // 使用cid和formUid
    if (result.userStatus) {
      // 641、30、1081，关闭cid清除逻辑
      if (companyUUID !== 'lom9e5qw' && companyUUID !== 'l2y7m6c5' && companyUUID !== 'lwq5wwol') {
        if (result.userStatus.cid) {
          setLocal(STORAGE_KEY.CID, result.userStatus.cid);
        } else {
          removeLocal(STORAGE_KEY.CID);
        }
      }
      if (result.userStatus.formUid) {
        setLocal(STORAGE_KEY.FORM_UID, result.userStatus.formUid);
      } else {
        removeLocal(STORAGE_KEY.FORM_UID);
      }
    }
    // 不再使用cookie维护逻辑
    // // cid过期分步做，交互需求时不再保存cookie信息
    // if (result.userStatus && result.userStatus?.status) {
    //   // 状态是老用户，更新cookie信息
    //   // setCookie(userCkey, JSON.stringify(result.userStatus));
    // } else {
    //   // 状态是新用户，删除cookie
    //   // removeCookie(userCkey);
    // }
  }
};

const checkConfigAvailable = () => {
  const config = getAndValidConfig();
  if (config) {
    const oldTime = config.loadTime;
    if (oldTime) {
      const current = new Date();
      if (current?.getTime() - oldTime < 60 * 60 * 1000) {
        // 当前时间小于配置时间+过期时间，有效
        return true;
      }
    }
  }
  return false;
};

// 存储coupon
// URL 带 coupon 时写入 session，用于后续配置匹配校验
const storeCoupon = () => {
  const coupon = getQueryVariable('coupon');
  if (coupon) {
    setSession(STORAGE_KEY.COUPON_STORE_SESSION, coupon);
  }
};

// 根据coupon查看本地配置是否有效
const checkCoupnMatchConfig = () => {
  // 本地配置过期校验开关，打开则本地也会校验配置过期，过期时间暂定1h
  const localCheckAvailable = false;
  if (localCheckAvailable) {
    if (!checkConfigAvailable()) {
      // 本地配置超时，清除
      observer.clearConfig();
      removeSession(STORAGE_KEY.POPUP);
      // 触发配置移除事件
      window.dispatchEvent(
        new CustomEvent(EVENTS.POPUP.REMOVED, {
          detail: { reason: REMOVE_TYPE.EXPIRED }
        })
      );
      return false;
    }
  }
  const coupon = getQueryVariable('coupon');
  if (coupon) {
    // 请求带 coupon 时与 session 中暂存的 coupon 比对，一致才复用本地配置
    const oldCoupon = getSession(STORAGE_KEY.COUPON_STORE_SESSION);
    if (coupon == oldCoupon) {
      // 新旧coupon相同
      return true;
    } else {
      // 不相同，本地配置不可用，清除本地配置
      observer.clearConfig();
      removeSession(STORAGE_KEY.POPUP);
      // 触发配置移除事件
      window.dispatchEvent(
        new CustomEvent(EVENTS.POPUP.REMOVED, {
          detail: { reason: REMOVE_TYPE.COUPON_MISMATCH }
        })
      );
      return false;
    }
  } else {
    // 请求参数没有coupon，配置一定可用
    return true;
  }
};

const perLoadImage = (url) => {
  const image = document.createElement('img') as any;
  image.classList.add('cartx-preload');
  image.src = url;
  image.setAttribute('style', 'position:fixed; left:200vw; top:0;');
  image.fetchpriority = 'high';
  image.onload = function () {
    try {
      image?.remove();
    } catch (e) {
      // console.log(e);
    }
  };
  document.body.append(image);
  setTimeout(() => {
    try {
      image?.remove();
    } catch (e) {
      // console.log(e);
    }
  }, 2000);
};

const perLoadFont = (font) => {
  const txt = document.createElement('div');
  txt.classList.add('cartx-preloadfont');
  txt.innerText = 'A';
  txt.setAttribute('style', `position:fixed; left:200vw; top:0; font-family:${font}`);
  document.body.append(txt);
  setTimeout(() => {
    try {
      txt?.remove();
    } catch (e) {
      // console.log(e);
    }
  }, 2000);
};

const htmlPreloadImage = (url) => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.href = url;
  link.as = 'image';
  document.head.appendChild(link);
};

const createReadyDom = () => {
  const image = document.createElement('div');
  image.classList.add('cartx-preload');
  image.setAttribute('style', 'position:fixed; left:200vw; top:0;');
  document.body.append(image);
  setTimeout(() => {
    try {
      image?.remove();
    } catch (e) {
      // console.log(e);
    }
  }, 2000);
};

const preLoadImageAndFont = (popConfig) => {
  if (!popConfig) {
    return;
  }
  // html是否加载完成
  const readyStateComplete = window?.document?.readyState === 'complete';

  if (!readyStateComplete) {
    createReadyDom();
  }

  const preload = window?.CARTSEE_SUBSCRIBE?.config?.preload;
  if (preload === false) {
    console.log('preload is false', preload);
    return 'preload is false';
  }

  // 预加载资源
  const preloadByReadyState = (url?: string) => {
    if (!url) return;
    if (!readyStateComplete) {
      htmlPreloadImage(url);
    } else {
      perLoadImage(url);
    }
  };

  if (popConfig?.settings?.styles?.styleMap) {
    const styleMap = popConfig?.settings?.styles?.styleMap;
    const allKeys = Object.keys(styleMap);
    const cartxFonts = allKeys.filter((item) => styleMap?.[item]?.['font-family']?.includes('Cartx'));
    for (let i = 0; i < cartxFonts.length; i++) {
      const font = cartxFonts[i];
      perLoadFont(styleMap?.[font]?.['font-family']);
    }
  }
  preloadByReadyState(popConfig?.settings?.logo?.imgUrl);
  if (popConfig?.settings?.typesetting) {
    const typesetting = popConfig?.settings?.typesetting;
    if (['mc8tam34'].includes(companyUUID) && popConfig.triggerEventType === 2) {
      // 不预加载
    } else {
      preloadByReadyState(typesetting.imgUrl);
    }
    preloadByReadyState(typesetting.imgUrlEnd);
    preloadByReadyState(typesetting.pointImgUrl);
    preloadByReadyState(typesetting.bgImgUrl);
    preloadByReadyState(typesetting.leftAdImage);
    preloadByReadyState(typesetting.rightAdImage);

    preloadByReadyState(typesetting.middleBgImgUrl);
    preloadByReadyState(typesetting.endBgImgUrl);
  }
  if (popConfig?.settings?.position?.iconShow === 1) {
    if (popConfig?.settings?.position?.iconUrl?.length > 0) {
      preloadByReadyState(popConfig?.settings?.position?.iconUrl);
    } else {
      // 预加载默认图片
      preloadByReadyState(`${getCompanyStaticUrl()}Public/cartsee/formImage/2e642a01175554bfaf5ab0b4f1c9cc03.gif`);
    }
  }
  preloadByReadyState(popConfig?.settings?.texts?.textAreaImgUrl);
  preloadByReadyState(popConfig?.settings?.texts?.unsubscribedTextAreaImgUrl);
  preloadByReadyState(popConfig?.settings?.texts?.subscribedTextAreaImgUrl);
  preloadByReadyState(popConfig?.settings?.cover?.bgCoverImgUrl);
};

// 碰到0、2类型的弹窗预加载
export const preload02Pop = (res) => {
  if (res?.rets) {
    // console.log('开始预加载:', new Date().toLocaleString());
    // console.log('开始预加载');
    // 开始预加载
    const configList = JSON.parse(JSON.stringify(res?.rets));
    for (let i = 0; i < configList.length; i++) {
      const ret = configList[i];
      if (ret?.triggerEventType === 0 || ret?.triggerEventType === 2 || ret?.triggerEventType === 8 || ret?.successPageType === 1) {
        if (terminal && ret?.settings.rules.terminalType === 'mobile' && ret?.triggerEventType === 0) {
          return false;
        }
        if (!terminal && ret?.settings.rules.terminalType === 'pc' && ret?.triggerEventType === 0) {
          return false;
        }
        preLoadImageAndFont(ret);
      }
    }
  }
};

const preloadLazyLoad = (config, load) => {
  // console.log('检查预加载:', new Date().toLocaleString());
  // console.log('检查预加载');
  const preloads = document?.getElementsByClassName('cartx-preload');
  if (preloads && preloads.length > 0) {
    // console.log('等待预加载');
    setTimeout(() => {
      preloadLazyLoad(config, load);
    }, 500);
  } else {
    if (!!document?.fonts?.check) {
      let result = true;
      if (config?.settings?.styles?.styleMap) {
        const styleMap = config?.settings?.styles?.styleMap;
        const allKeys = Object.keys(styleMap);
        const cartxFonts = allKeys.filter((item) => styleMap?.[item]?.['font-family']?.includes('Cartx'));
        for (let i = 0; i < cartxFonts.length; i++) {
          const font = cartxFonts[i];
          const ff = styleMap?.[font]?.['font-family'];
          if (!document.fonts.check(`12px ${ff}`)) {
            // console.log('字体未加载完成');
            result = false;
            break;
          }
        }
      }
      if (result) {
        // console.log('所有字体加载完成');
        if (load) {
          load();
        }
      } else {
        const preloads = document?.getElementsByClassName('cartx-preloadfont');
        if (preloads && preloads.length > 0) {
          // console.log('等待预加载字体');
          setTimeout(() => {
            preloadLazyLoad(config, load);
          }, 500);
        } else {
          // console.log('字体加载超过2秒:', new Date().toLocaleString());
          // console.log('字体加载超过2秒');
          if (load) {
            load();
          }
        }
      }
    } else if (load) {
      // console.log('图片加载超过2秒:', new Date().toLocaleString());
      load();
    }
  }
};

// 请求配置
const getSessionConfig = () => {
  return new Promise((resolve, reject) => {
    // 先查看本地是否有配置，如果有则是同一个session
    // 请求完成
    if (observer.hasConfig() && checkCoupnMatchConfig()) {
      // resolve(JSON.parse(JSON.stringify(observer.config || {})));
      // 统一逻辑使用observe触发
      observer.on(resolve);
    } else {
      // 如果有请求
      if (observer.isRequesting()) {
        observer.on(resolve);
      } else if (observer.isNotRequesting()) {
        // 没有请求过
        const config = getAndValidConfig();
        if (config && checkCoupnMatchConfig()) {
          // 本地有，设置请求成功
          observer.on(resolve);
          // 防止逻辑混乱及数据篡改，所有回调统一使用observer.emit触发
          observer.emit(config);
        } else {
          // 设置状态为请求
          observer.setConfigRequesting();
          // 没有session配置，发起请求，请求失败自动重试
          getStrategy()
            .then((res: any) => {
              if (res) {
                // 拿到用户信息，保存后返回
                storeConfig(res);
                // abtest在load直接存储
                if (res?.abMapping) {
                  storeAbtestInfo(res?.abMapping);
                }
                // 预加载 灰度450、30、721、313
                // 延时预加载，如果触发弹窗的话，至少等弹窗js懒加载开始
                setTimeout(() => {
                  preload02Pop(res);
                }, 40);
                // 存储本地coupon
                storeCoupon();
                observer.on(resolve);
                // 防止逻辑混乱及数据篡改，所有回调统一使用observer.emit触发
                observer.emit(res);
              } else {
                // 没有数据，失败
                reject();
                observer.setGetConfigFailed();
                // 清除加购标记
                removeSession(STORAGE_KEY.ADD_CART_STATE);
              }
            })
            .catch((err) => {
              // 请求失败，拿不到配置，reject
              reject(err);
              observer.setGetConfigFailed();
            });
        }
      } else {
        // 请求失败
        reject();
      }
    }
  });
};

// 检查配置逻辑
const checkConfigFrom = (type) => {
  return new Promise((resolve, reject) => {
    // 有本地配置
    const storageConfig = getAndValidConfig();
    if (storageConfig && checkCoupnMatchConfig()) {
      // 有本地配置，且本地配置起作用

      // 直接读本地配置
      observer.readLocalStorage();
      // 读完后
      const localConfig = observer.config;
      const config = {};
      // 找到本地配置里的对应配置
      for (let i = 0; i < localConfig?.rets?.length; i++) {
        const popItem = localConfig?.rets[i];
        if (`${popItem?.triggerEventType}` === `${type}`) {
          // 需要取时间戳，目前先用lastModifi代替
          config[popItem.id] = popItem.settingsUpdateTimestamp;
        }
      }

      if (shouldSkipCheckConfigByLoadLimit(type)) {
        console.log('checkConfigFrom type=%s skip by load limit', type);
        return resolve(observer.config);
      }

      // 增加退出意图更新频率限制
      const EVENT_1_FREQUENCY_LIMIT = 1000 * 60 * 5;
      if (
        isShopifyOrTest() &&
        type === 1 &&
        [shopify[30], shopify[2631]].includes(companyUUID)
      ) {
        const lastCheckTime = getSession(STORAGE_KEY.POPUP_LAST_CHECK_TIME_1);
        const currentTime = new Date();
        if (lastCheckTime) {
          const timeDiff = currentTime.getTime() - new Date(lastCheckTime).getTime();
          // console.log('checkConfigFrom eventType=1 time diff', timeDiff);
          if (timeDiff < EVENT_1_FREQUENCY_LIMIT) {
            // console.log('checkConfigFrom eventType=1 time diff < 5 minutes, reject');
            return reject();
          }
        }
        setSession(STORAGE_KEY.POPUP_LAST_CHECK_TIME_1, currentTime.toISOString());
      }

      formEventV2({
        event: 'popup_config_check',
        eventType: type
      })
        .then((response) => {
          // console.log('数据上报成功')
        })
        .catch((e) => {});
      let configStartTime = new Date();
      // console.log('checkConfigFrom config', config, type);
      checkConfig(config, type, observer.config?.formGlobalSetting?.globalSettingTimestamp)
        .then((res) => {
          // 暂无接口，模拟请求
          // const allPops = observer.config.rets;
          // console.log('暂无接口，使用本地数据模拟', allPops, type);
          // res = {
          //   config:{},
          //   user:{},
          //   globalSetting:{}
          // };
          // for (let i = 0; i < allPops.length; i++) {
          //   const popItem = allPops[i];
          //   if (`${popItem?.triggerEventType}` === `${type}`) {
          //     res.config[popItem.id] = performance.now();
          //   }
          // }
          // console.log('模拟结果', res);
          // observer.update(type, res);
          // resolve(observer.config);

          const currentTime = new Date();
          if (res) {
            // console.log('拿到最新配置和用户信息', type, res);
            // 更新本地配置
            // 每次从localstorage中拿
            observer.update(type, res, currentTime?.getTime() - configStartTime?.getTime());
            resolve(observer.config);
          } else {
            // console.log('没请求到最新配置,使用本地配置');
            formEventV2({
              event: 'popup_config_check_result',
              eventType: type,
              result: '请求失败',
              duration: currentTime?.getTime() - configStartTime?.getTime()
            })
              .then((response) => {
                // console.log('数据上报成功')
              })
              .catch((e) => {});
            reject();
          }
        })
        .catch(() => {
          // console.log('失败1');
          reject();
        });
    } else {
      // 没有本地配置，或本地配置不可用
      // console.log('没有本地配置，或本地配置不可用');
      reject();
    }
  });
};

export { getSessionConfig, checkCoupnMatchConfig, checkConfigFrom, checkConfigAvailable, preloadLazyLoad };
